var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "50px", height: "90%" },
          attrs: {
            title: _vm.title,
            width: 1300,
            visible: _vm.visible,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "关闭",
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c("a-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("关闭"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  attrs: { layout: "inline" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchQuery.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _vm.organLabel
                        ? _c(
                            "a-col",
                            { attrs: { md: 4, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: _vm.organLabel,
                                    labelCol: { span: 5 },
                                    wrapperCol: { span: 18, offset: 1 },
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        dropdownMatchSelectWidth: false,
                                        showSearch: "",
                                        optionFilterProp: "children",
                                      },
                                      on: { search: _vm.handleSearchSupplier },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "dropdownRender",
                                            fn: function (menu) {
                                              return _c(
                                                "div",
                                                {},
                                                [
                                                  _c("v-nodes", {
                                                    attrs: { vnodes: menu },
                                                  }),
                                                  _c("a-divider", {
                                                    staticStyle: {
                                                      margin: "4px 0",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-btn",
                                                      on: {
                                                        mousedown: (e) =>
                                                          e.preventDefault(),
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.loadSupplier(
                                                            _vm.organLabel
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("a-icon", {
                                                        attrs: {
                                                          type: "reload",
                                                        },
                                                      }),
                                                      _vm._v(" 刷新列表"),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2825766076
                                      ),
                                      model: {
                                        value: _vm.queryParam.organId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "organId",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.organId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.supplierList,
                                      function (item, index) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: index,
                                            attrs: { value: item.id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.supplier) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-col",
                        { attrs: { md: 5, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单号",
                                labelCol: { span: 5 },
                                wrapperCol: { span: 18, offset: 1 },
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入单据编号" },
                                model: {
                                  value: _vm.queryParam.number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "number", $$v)
                                  },
                                  expression: "queryParam.number",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 5, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "商品",
                                labelCol: { span: 5 },
                                wrapperCol: { span: 18, offset: 1 },
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "条码|名称|规格|型号" },
                                model: {
                                  value: _vm.queryParam.materialParam,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParam,
                                      "materialParam",
                                      $$v
                                    )
                                  },
                                  expression: "queryParam.materialParam",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据日期",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-range-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  format: "YYYY-MM-DD",
                                  placeholder: ["开始时间", "结束时间"],
                                },
                                on: {
                                  change: _vm.onDateChange,
                                  ok: _vm.onDateOk,
                                },
                                model: {
                                  value: _vm.queryParam.createTimeRange,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParam,
                                      "createTimeRange",
                                      $$v
                                    )
                                  },
                                  expression: "queryParam.createTimeRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "table-page-search-submitButtons",
                          staticStyle: { float: "left", overflow: "hidden" },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 4, sm: 24 } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.searchQuery },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.searchReset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-table", {
            ref: "table",
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              components: _vm.handleDrag(_vm.columns),
              pagination: _vm.ipagination,
              loading: _vm.loading,
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "numberCustomRender",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.myHandleDetail(record)
                          },
                        },
                      },
                      [_vm._v(_vm._s(record.number))]
                    ),
                  ])
                },
              },
              {
                key: "customRenderStatus",
                fn: function (text, record) {
                  return [
                    record.status === "0"
                      ? _c("a-tag", { attrs: { color: "red" } }, [
                          _vm._v("未审核"),
                        ])
                      : _vm._e(),
                    record.status === "1"
                      ? _c("a-tag", { attrs: { color: "green" } }, [
                          _vm._v("已审核"),
                        ])
                      : _vm._e(),
                    record.status === "2" &&
                    _vm.queryParam.subType === "采购订单"
                      ? _c("a-tag", { attrs: { color: "cyan" } }, [
                          _vm._v("完成采购"),
                        ])
                      : _vm._e(),
                    record.status === "2" &&
                    _vm.queryParam.subType === "销售订单"
                      ? _c("a-tag", { attrs: { color: "cyan" } }, [
                          _vm._v("完成销售"),
                        ])
                      : _vm._e(),
                    record.status === "3" &&
                    _vm.queryParam.subType === "采购订单"
                      ? _c("a-tag", { attrs: { color: "blue" } }, [
                          _vm._v("部分采购"),
                        ])
                      : _vm._e(),
                    record.status === "3" &&
                    _vm.queryParam.subType === "销售订单"
                      ? _c("a-tag", { attrs: { color: "blue" } }, [
                          _vm._v("部分销售"),
                        ])
                      : _vm._e(),
                    record.status === "9" &&
                    _vm.queryParam.subType === "采购订单"
                      ? _c("a-tag", { attrs: { color: "orange" } }, [
                          _vm._v("审核中"),
                        ])
                      : _vm._e(),
                    record.status === "9" &&
                    _vm.queryParam.subType === "销售订单"
                      ? _c("a-tag", { attrs: { color: "orange" } }, [
                          _vm._v("审核中"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("bill-detail", { ref: "billDetail" }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }